export default class CaracteristiqueAccordionHeadingController {
	constructor() {}
}
CaracteristiqueAccordionHeadingController.$inject = [];
